/**
 * Remove 'today' option after Smart Online Order checkout loads.
 */
jQuery(document).ready(function ($) {
	$("#moo-checkout").each(function () {
		const $checkout = $(this);
		const $day = $checkout.find("#moo_pickup_day");
		let refreshcount = 0;
		let hasUpdatedMessage = false;
		let $pudaymsg = null;
		let currentDifferenceDays = null;

		const updatePickupDays = () => {
			return new Promise(function (resolve, reject) {
				$.ajax({
					type: "get",
					dataType: "json",
					url: ddisoo_checkout.ajaxurl,
					data: {
						action: "ddisoo_update_data",
						security: ddisoo_checkout.nonce,
					},
				}).done(function (response) {
					if (
						typeof response.data !== "undefined" &&
						typeof response.data.data !== "undefined"
					) {
						ddisoo_checkout = response.data;
					}
				});
			});
		};

		const getCurrentDay = () => {
			if (
				ddisoo_checkout.currentDate !== undefined &&
				null !== ddisoo_checkout.currentDate &&
				"" !== ddisoo_checkout.currentDate
			) {
				return ddisoo_checkout.currentDate;
			} else {
				return null;
			}
		};

		const updateDaysUntilPickupMessage = (differenceDays) => {
			if (null !== $pudaymsg && currentDifferenceDays !== differenceDays) {
				currentDifferenceDays = differenceDays;

				let pickupmsg =
					typeof ddisoo_checkout.data.pickup_daysloc_message !== "undefined"
						? ddisoo_checkout.data.pickup_daysloc_message
						: "";
				let pickupwhen = "in " + differenceDays + " days";

				if (1 === differenceDays) {
					pickupwhen = "tomorrow";
				}

				pickupmsg = pickupmsg.replace("%when%", pickupwhen);

				$pudaymsg.html(pickupmsg);
			} else if (null === currentDifferenceDays && null !== $pudaymsg) {
				$pudaymsg.html("");
			}
		};

		const updateDaysUntilPickup = (day) => {
			if (day !== undefined && null !== day && "" !== day) {
				const currentDate = getCurrentDay();
				if (null !== currentDate) {
					let year = currentDate.year;
					if (
						"Jan" !== currentDate.month &&
						day.toLowerCase().includes("jan")
					) {
						year++;
					}

					day = day + ", " + year;

					const now = new Date(currentDate.fullDate);
					const pickup = new Date(day);

					const differenceTime = pickup.getTime() - now.getTime();

					// To calculate the no. of days between two dates
					const differenceDays = Math.ceil(differenceTime / (1000 * 3600 * 24));
					updateDaysUntilPickupMessage(differenceDays);
				}
			}
		};

		$day.change(function () {
			updateDaysUntilPickup($(this).val());
		});

		setInterval(function () {
			if (ddisoo_checkout.data && 0 < ddisoo_checkout.data.remove.length) {
				let hasRemoved = false;
				if (0 < $day.length) {
					let remStrings = [];

					/**
					 * Remove entire days
					 */
					ddisoo_checkout.data.remove.forEach((rmv) => {
						remStrings.push('option[value="' + rmv + '"]');
						delete sooCheckout.options.pickupTimes[rmv];
					});

					$day.find(remStrings.join(",")).each(function () {
						$(this).remove();
						hasRemoved = true;
					});

					/**
					 * Remove times if closing early
					 */
					ddisoo_checkout.data.earlyClosing.forEach((rmv) => {
						// eslint-disable-next-line camelcase
						for (const [rmvday, earlyCutoffTime] of Object.entries(rmv)) {
							let doTimeDelete = false;
							let remHoursStrings = [];
							let remHours = [];

							const current_pickup_time =
								sooCheckout.options.pickupTimes[rmvday];
							// eslint-disable-next-line camelcase
							if (
								current_pickup_time &&
								typeof current_pickup_time !== "undefined"
							) {
								// Ok this day exists in the array.

								// eslint-disable-next-line camelcase
								current_pickup_time.forEach((rmvdaytime) => {
									if (rmvdaytime === earlyCutoffTime.reopen) {
										doTimeDelete = false;
									}

									if (true === doTimeDelete) {
										// eslint-disable-next-line camelcase
										const index =
											sooCheckout.options.pickupTimes[rmvday].indexOf(
												rmvdaytime
											);

										if (-1 !== index) {
											remHoursStrings.push(
												'option[value="' + rmvdaytime + '"]'
											);

											//sooCheckout.options.pickupTimes[rmvday].splice(index, 1);
											remHours.push(rmvdaytime);

											// eslint-disable-next-line camelcase
											hasRemoved = true;
										}
									}

									// We have found the cutoff time, delete going forward.
									if (rmvdaytime === earlyCutoffTime.close) {
										doTimeDelete = true;
									}
								});

								if (remHours.length > 0) {
									remHours.forEach((hour) => {
										const index =
											sooCheckout.options.pickupTimes[rmvday].indexOf(hour);
										if (index > -1) {
											sooCheckout.options.pickupTimes[rmvday].splice(index, 1);
										}
									});
								}

								if ($day.val() === rmvday) {
									const $hours = $checkout.find("#moo_pickup_hour");
									if (0 < $hours.length) {
										$hours.find(remHoursStrings.join(",")).each(function () {
											$(this).remove();
											hasRemoved = true;
										});
									}
								}
							}
						}
					});

					if (hasRemoved) {
						$day.val($day.find("option:eq(0)").attr("value"));
						$day.trigger("change");
					}
					refreshcount++;

					if (0 === refreshcount % 120) {
						/**
						 * Hit the server and make sure we haven't passed the cut-off time yet.
						 */
						updatePickupDays();
					}
				}

				if (!hasUpdatedMessage) {
					hasUpdatedMessage = true;

					$pudaymsg = $checkout.find("#pickupdaymessage");

					/**
					 * Legacy: This HTML and messaging is added via a PHP hook now.
					 * In case this changes in the future, or we roll back to an old version of SOO, this code is left in place.
					 */
					if ($pudaymsg.length <= 0) {
						const $msgrow = $day.closest(".moo-row").next(".moo-row");
						const checkout_message =
							typeof ddisoo_checkout.data.checkout_message !== "undefined"
								? ddisoo_checkout.data.checkout_message
								: "";

						if (0 < $msgrow.length) {
							$msgrow
								.children(".moo-col-md-12")
								.html(
									'<div id="pickupdaymessage"></div><div>' +
										checkout_message +
										"</div>"
								);
						} else {
							$(
								'<div class="moo-row"><div class="moo-col-md-12"><div id="pickupdaymessage"></div><div>' +
									checkout_message +
									"</div></div></div>"
							).insertAfter($day.closest(".moo-row"));
						}
					}

					if (0 < $day.length) {
						updateDaysUntilPickup($day.val());
					}
				}
			}

			const $ordertypes = $checkout.find(
				"#moo-checkout-form-ordertypes .soo-checkout-radio-input"
			);

			if ($ordertypes.length > 0) {
				if ($ordertypes.filter(":checked").length <= 0) {
					$ordertypes.eq(0).attr("checked", true).trigger("change");
				}
			}
		}, 250);

		if (ddisoo_checkout.data.tax_exempt_message) {
			let $order_type_radios = null;

			$order_type_radios = $checkout.find(
				"#moo-checkout-form-ordertypes .soo-checkout-radio-input"
			);

			$order_type_radios.each(function () {
				const $orderType = $(this);

				const $label = $orderType.siblings("label");

				const txt = $label.text().toLowerCase();

				if (txt.includes("tax-exempt") || txt.includes("tax exempt")) {
					$(
						'<div class="ordertype-notice">' +
							ddisoo_checkout.data.tax_exempt_message +
							"</div>"
					).insertAfter($label);
				}
			});
		}
	});
});
